export default __webpack_public_path__ + "img/1_7-51f518b5.png";